import { APP_ROUTES } from '../../contants/routes';

export const ROUTING_MAP = {
  quote: APP_ROUTES.SEARCH_QUOTE,
  dashboard: APP_ROUTES.DASHBOARD,
  // routingGuide: APP_ROUTES.ROUTING_GUIDE,
  auction: APP_ROUTES.AUCTION,
  routingGuide: APP_ROUTES.HAL_ROUTING_GUIDE,

  underConstruction: 'underConstruction',
};
